import React from "react";
import { Link } from "react-router-dom";
import { MapPin, House, SealCheck } from "@phosphor-icons/react";

export default function PropertyCard({ property }) {
  const img = (property.images && property.images[0]) || "";
  return (
    <Link to={`/rentals/${property.id}`}
      className="group block bg-white rounded-2xl border border-black/5 overflow-hidden hover:-translate-y-1 hover:shadow-xl transition-[transform,box-shadow] duration-300"
      data-testid={`property-card-${property.id}`}>
      <div className="relative aspect-[4/3] overflow-hidden bg-stone">
        {img ? (
          <img src={img} alt={property.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-neutral-300">
            <House size={48} weight="duotone" />
          </div>
        )}
        <div className="absolute top-4 left-4 px-3 py-1 rounded-full glass text-xs tracking-wider uppercase text-midnight">{property.room_type}</div>
        <div className="absolute top-4 right-4 px-3 py-1 rounded-full bg-midnight/85 text-bone text-xs">{property.furnishing}</div>
      </div>
      <div className="p-6">
        <h3 className="font-serif text-xl text-midnight mb-1 group-hover:text-gold transition-colors line-clamp-1">{property.title}</h3>
        <div className="flex items-center gap-1 text-sm text-neutral-500 mb-4">
          <MapPin size={14} weight="duotone" className="text-gold" />
          <span className="line-clamp-1">{property.locality ? `${property.locality}, ` : ""}{property.city}</span>
        </div>
        <div className="flex items-end justify-between pt-3 border-t border-black/5">
          <div>
            <p className="text-xs uppercase tracking-widest text-neutral-500">Monthly rent</p>
            <p className="font-serif text-2xl text-midnight">₹{property.monthly_rent.toLocaleString("en-IN")}</p>
          </div>
          <div className="text-right">
            <p className="text-xs uppercase tracking-widest text-neutral-500">Deposit</p>
            <p className="text-sm text-midnight">₹{property.security_deposit.toLocaleString("en-IN")}</p>
          </div>
        </div>
        <div className="flex items-center gap-2 text-xs text-neutral-500 mt-3">
          <span>{property.lock_in_months} mo lock-in</span>
          <span>·</span>
          <span>{property.preferred_tenant}</span>
        </div>
      </div>
    </Link>
  );
}
